import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Anchor } from "lucide-react";
import { api, setToken } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password: pw });
      setToken(r.data.token);
      toast.success("Welcome back, Nate.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F6F5] grain-bg flex items-center justify-center px-4">
      <form
        onSubmit={submit}
        className="relative z-10 w-full max-w-sm bg-white border border-border rounded-md p-8 shadow-sm"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2 mb-6">
          <Anchor className="text-[#1A3C5A]" size={22} strokeWidth={2} />
          <div className="font-display font-bold text-lg tracking-tight text-[#1A3C5A]">Admin · Southern Maine Events</div>
        </div>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label htmlFor="email" className="text-xs font-display uppercase tracking-widest text-slate-500">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   data-testid="admin-email-input" autoFocus />
          </div>
          <div className="space-y-1">
            <Label htmlFor="pw" className="text-xs font-display uppercase tracking-widest text-slate-500">Password</Label>
            <Input id="pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                   data-testid="admin-password-input" />
          </div>
        </div>
        <Button
          type="submit"
          disabled={loading}
          className="w-full mt-6 bg-[#1A3C5A] hover:bg-[#12293e] text-white font-display"
          data-testid="admin-login-submit"
        >
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
